import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SESSION_EXP_STORAGE_KEY } from '../constants/auth';
import { clearStore } from '../store/actions/general';
import { statusIsGood } from '../utils';

export const useHandleLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return async () => {
    const rawResp = await fetch('/api/auth/logout', {
      method: 'POST',
    });
    if (!statusIsGood(rawResp.status)) {
      // We don't expect this to happen, and either way the user will
      // be logged out. But log it if we do have a bad response from the server.
      console.error('Something went wrong when logging out user.');
    }
    dispatch(clearStore());
    localStorage.removeItem(SESSION_EXP_STORAGE_KEY);
    navigate('/login', { replace: true });
  };
};
